import { Form } from 'ht-styleguide';
import { Children } from 'types/base.types';
/**
 * Base/Generalized encapsulation of the user components with form
 *
 * @param {any} chilren
 * @returns {JSX.Element}
 * @constructor
 */
export const GridLayoutForm = ({ children }: { children: Children }) => <Form onSubmit={() => false}>{children}</Form>;
